import { Navigate, useLocation } from "react-router-dom"

import { useAuth } from "@/contexts/AuthContext"

/**
 * Wraps the authenticated section of the app. If no token is present,
 * redirect to /login and remember where the user was trying to go so we
 * can send them back after login (via location.state.from).
 */
export default function ProtectedRoute({
  children,
}: {
  children: React.ReactNode
}) {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
